import React from "react";
import LandingPage from "../../scenes/LandingPage";
import LandingLayout from "../Layouts/LandingLayout";

const LoginPage = () => (
  <LandingLayout>
    <LandingPage />
  </LandingLayout>
);

export default LoginPage;



// WEBPACK FOOTER //
// ./src/util/Router/LoginPage.js